import {
  Box,
  Popover,
  Typography,
} from "@mui/material";
import classNames from "classnames";
import React, { useEffect, useState } from "react";

const UserInfoModal = ({ isOpen, onClose, data }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose(false);
  };

  return (
    <Popover
      open={open}
      onClose={handleClose}
      className={classNames(
        "user-info-popover")}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      aria-labelledby="user-info"
      sx={{
        marginTop: 5,
      }}
    >
      <Box
        sx={{
          width: 'auto',
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 2,
          "& .MuiTooltip-tooltip": {
            backgroundColor: "inherit",
            color: "inherit",
            boxShadow: "none",
          },
        }}
      >
        <Box mt={1} sx={{ margin: 0 }}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
            {data?.fullName}
          </Typography>
          {data?.email ? (
            <Box sx={{ display: "flex", gap: "0.5rem" }}>
              <Typography
                variant="body2"
                color="text.secondary"
                className="email"
              >
                Email
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data?.email}
              </Typography>
            </Box>
         ) : (
            <></>
          )} 
        </Box>
      </Box>
    </Popover>
  );
};

export default UserInfoModal;
